import CompanyAvatar from "./CompanyAvatar";

export type { ICompanyAvatarProps } from "./CompanyAvatar";

export default CompanyAvatar;
